// ============================================================
// ByOurConsent.com -- Terms of Service
// /terms
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8b6a3a', marginBottom: '8px' }}>
            {title}
        </div>
        <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
            {children}
        </div>
    </div>
);

const TermsPage = () => (
    <>
        <Helmet><title>Terms of Service — By Our Consent</title></Helmet>
        <Nav />

        <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>Terms of service</h1>
                <p style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '6px' }}>Last updated: June 2026</p>
            </div>
        </div>

        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

            <Section title="Acceptance">
                By accessing or using By Our Consent ("the platform"), you agree to be bound
                by these Terms of Service. If you do not agree, do not use the platform.
            </Section>

            <Section title="Use of the platform">
                By Our Consent is a civic engagement platform dedicated to constitutional
                governance, accountability, and civic education. You agree to use the platform
                only for lawful purposes and in ways that do not infringe the rights of others.
                <br /><br />
                You may not use the platform to:
                <ul style={{ margin: '8px 0 0 1.25rem', padding: 0, lineHeight: 1.9 }}>
                    <li>Post or distribute illegal, harassing, or defamatory content</li>
                    <li>Impersonate any person or organization</li>
                    <li>Interfere with the operation of the platform</li>
                    <li>Use automated tools to scrape or abuse the platform</li>
                </ul>
            </Section>

            <Section title="Accounts">
                You are responsible for maintaining the confidentiality of your account
                credentials. You are responsible for all activity that occurs under your account.
                We reserve the right to suspend or terminate accounts that violate these terms.
            </Section>

            <Section title="Content and contributions">
                By submitting articles, forum posts, or other content, you grant By Our Consent
                a non-exclusive, royalty-free license to publish and display that content on the
                platform. You retain ownership of your content.
                <br /><br />
                You represent that any content you submit is your own original work, does not
                violate any third-party rights, and is factually accurate to the best of your knowledge.
            </Section>

            <Section title="Store and purchases">
                All sales are final except as described in our{' '}
                <Link to="/returns" style={{ color: '#8b1a1a' }}>returns policy</Link>.
                Prices are subject to change. We reserve the right to cancel orders at our discretion.
            </Section>

            <Section title="Intellectual property">
                The By Our Consent name, logo, and platform design are our intellectual property.
                Articles and content published on the platform are the property of their respective authors.
                You may not reproduce or redistribute platform content without permission.
            </Section>

            <Section title="Limitation of liability">
                By Our Consent is provided "as is" without warranties of any kind. We are not
                liable for any indirect, incidental, or consequential damages arising from your
                use of the platform. Our total liability shall not exceed the amount you paid
                us in the 12 months preceding the claim.
            </Section>

            <Section title="Changes to these terms">
                We may update these terms from time to time. Continued use of the platform
                after changes constitutes acceptance of the updated terms. We will notify
                registered members of material changes by email.
            </Section>

            <Section title="Contact">
                Questions about these terms? Contact us at{' '}
                <a href="mailto:info@byourconsent.com" style={{ color: '#8b1a1a' }}>info@byourconsent.com</a>.
            </Section>

        </div>
        <Footer />
    </>
);

export default TermsPage;
